import MileageSalesServiceApp from "../MileageSalesServiceApp.vue";
import ServiceInit from "../views/mileage/ServiceInit.vue";
import Home from "../views/mileage/Home.vue";
import SalesSetting from "../views/mileage/SalesSetting.vue";
import Order from "../views/mileage/Order.vue";
import AdditionalService from "../views/mileage/AdditionalService.vue";
import Payment from "../views/mileage/Payment.vue";

export const MileageSalesService = [
  {
    path: "/",
    name: "MileageSalesService",
    redirect: {
      name: "MileageSalesServiceApp",
    },
  },
  {
    path: "/mileage",
    redirect: {
      name: "ServiceInit",
    },
    name: "MileageSalesServiceApp",
    component: MileageSalesServiceApp,
    children: [
      {
        path: "/mileage/init",
        name: "ServiceInit",
        component: ServiceInit,
      },
      {
        path: "/mileage/:mall_id/home",
        name: "Home",
        component: Home,
      },
      {
        path: "/mileage/:mall_id/sales_setting",
        name: "SalesSetting",
        component: SalesSetting,
      },
      {
        path: "/mileage/:mall_id/order",
        name: "Order",
        component: Order,
      },
      {
        path: "/mileage/:mall_id/additional_service",
        name: "AdditionalService",
        component: AdditionalService,
        props: true,
      },
      {
        path: "/mileage/:mall_id/payment",
        name: "Payment",
        component: Payment,
        props: true,
      },
    ],
  },
];
